import React from "react";
import StatCard from "../Components/StatCard";
import SectionLabel from "../Components/SectionLabel";
import StatGrid from "../Components/statGrid";

const TokensTab = ({ btncData = {} }) => {
  return (
    <>
      {/* ── BTNC ── */}
      <SectionLabel>BTNC overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Total BTNC"
          value={btncData?.totalBtnc}
          sub="All time combined"
          accent="green"
        />
        <StatCard
          label="Total credit"
          value={btncData?.totalBtncCredit}
          sub="Total BTNC earned"
          accent="blue"
        />
        <StatCard
          label="Total debit"
          value={btncData?.totalBtncDebit}
          sub="Total BTNC spent"
          accent="red"
        />
      </StatGrid>

      <SectionLabel>BTNC credit breakdown</SectionLabel>
      <StatGrid>
        <StatCard
          label="From game"
          value={btncData?.totalBtncCreditWithGame}
          sub="Earned via gameplay"
          accent="teal"
        />
        <StatCard
          label="From tasks"
          value={btncData?.totalBtncCreditWithTask}
          sub="Earned via tasks"
          accent="blue"
        />
        <StatCard
          label="From referrals"
          value={btncData?.totalBtncCreditWithReferral}
          sub="Earned via referrals"
          accent="purple"
        />
        <StatCard
          label="Admin awarded"
          value={btncData?.totalBtncCreditWithAdmin}
          sub="Manually awarded"
          accent="amber"
        />
        <StatCard
          label="Other sources"
          value={btncData?.totalBtncCreditWithEtc}
          sub="Miscellaneous credits"
          accent="coral"
        />
      </StatGrid>
    </>
  );
};

export default TokensTab;
